// Template bodies: wa_meta/config.template_body first, else the old admin's hardcoded map (review point 7).
import type { WaConfig } from "@/data/types";
import type { Reg } from "./people";

export const FALLBACK_TEMPLATES: Record<string, string> = {
  registration_confirmed: `Dear {{name}},

Your registration for {{event_name}} is confirmed.

Registration number: {{reg_no}}
Dates attending: {{dates}}
Number of days: {{days}}

To settle in comfortably and experience the Homa/Puja fully, please arrive at least 45 minutes before the Puja begins.

For any queries, please contact {{contact}}.

We look forward to welcoming you. Jai Gurudev!

Team Vaidic Dharma Sansthan, Mumbai`,
  navaratri_registration_confirmed: `Hello {{name}},

Your registration for Mumbai Navaratri 2026, organised by Vaidic Dharma Sansthan, Mumbai, is confirmed.

Registration number: {{reg_no}}
Dates: {{dates}}
Number of days: {{days}}

Please arrive at least 45 minutes before the start time.`,
};

export function templateBody(name: string | null | undefined, config: WaConfig | null): string | null {
  if (!name) return null;
  if (config && config.template === name && config.templateBody) return config.templateBody;
  return FALLBACK_TEMPLATES[name] ?? null;
}

export type Part = { text: string; v?: boolean };

/** Split a body into text and filled-in parts (for the highlighted `.var` spans). Unknown vars stay `{{x}}`. */
export function renderParts(body: string, vars: Record<string, string>): Part[] {
  const out: Part[] = [];
  let last = 0;
  for (const m of body.matchAll(/\{\{(\w+)\}\}/g)) {
    const i = m.index ?? 0;
    if (i > last) out.push({ text: body.slice(last, i) });
    const v = vars[m[1]!];
    out.push(v == null || v === "" ? { text: m[0] } : { text: v, v: true });
    last = i + m[0].length;
  }
  if (last < body.length) out.push({ text: body.slice(last) });
  return out;
}

/**
 * Vars for a registration: the ledger's real `vars` once sent, else the sender's params from the snapshot
 * (`wa publish`), else a preview built from the snapshot using config.params ("Column" | "config:<key>" | "const:<value>").
 */
export function varsFor(reg: Reg, config: WaConfig | null): Record<string, string> {
  if (reg.ledger && Object.keys(reg.ledger.vars).length) return reg.ledger.vars;
  const params = reg.recipient?.params;
  if (params && Object.keys(params).length) return params;
  const known: Record<string, string> = {
    name: reg.name,
    reg_no: reg.baseKey,
    days: reg.days,
    dates: reg.dates,
    event_name: config?.eventName ?? "",
  };
  const out: Record<string, string> = {};
  for (const [param, src] of Object.entries(config?.params ?? {})) {
    if (src.startsWith("const:")) out[param] = src.slice(6);
    else if (src === "config:event_name") out[param] = config?.eventName ?? "";
    else if (known[param] != null) out[param] = known[param]!;
  }
  return Object.keys(out).length ? out : known;
}
